(function () {
    'use strict';

    angular
        .module("skillsApp")
        .controller("SelectDepartmentFunctionsDialogController", SelectDepartmentFunctionsDialogController);

    function SelectDepartmentFunctionsDialogController($uibModalInstance, $scope, $translate, $q, config, portalGroupService) {
        var vm = this;
        var departmentsAndFunctions = null;
        var departmentFunctions = {};

        vm.departments = [];
        vm.functions = [];
        vm.selection = [];
        vm.hideOnlyAssignToExistingCombinationsCheckbox = config.settings.custom.onlyAssignToExistingCombinations;
        vm.onlyAssignToExistingCombinations = true;

        vm.departmentsFunctionsLink = {
            addAllDepartments: false,
            addAllFunctions: false,
            userChosenFunctions: [],
            userChosenDepartments: []
        };
        vm.dropDownDepartmentSettings = {
            idProp: 'id',
            displayProp: 'name',
            selectTitle: $translate.instant('specific_departments') + '...'
        };
        vm.dropDownFunctionSettings = {
            idProp: 'roleId',
            displayProp: 'roleName',
            selectTitle: $translate.instant('specific_functions') + '...'
        };
        
        vm.cancel = cancel;
        vm.ok = ok;
        vm.toggleOnlyAssignToExistingCombinations = toggleOnlyAssignToExistingCombinations;

        $scope.$watch('vm.departmentsFunctionsLink', function (n, o) {
            if (n == o) return;
            if (n.addAllDepartments != o.addAllDepartments || n.userChosenDepartments.length != o.userChosenDepartments.length) {
                _updateAvailableFunctions();
            }
            _updateSelection();
        }, true);

        portalGroupService.getDepartmentsAndFunctions().then(result => {
            departmentsAndFunctions = result;

            vm.departments = result.departments;
            if (!vm.onlyAssignToExistingCombinations) vm.functions = result.functions;
        });

        function _updateAvailableFunctions() {
            var deferred = $q.defer();

            if (vm.onlyAssignToExistingCombinations) {
                var deps = vm.departmentsFunctionsLink.addAllDepartments ? departmentsAndFunctions.departments : vm.departmentsFunctionsLink.userChosenDepartments;

                return $q.all(deps.map(dep => {
                    if (departmentFunctions[dep.id] != null) return departmentFunctions[dep.id];

                    return portalGroupService.getFunctions(dep.id).then(functions => {
                        departmentFunctions[dep.id] = functions;
                        return functions;
                    });
                })).then(result => {
                    vm.functions = _.chain(result).flatten().uniq('roleId').sortBy(role => { return role.roleName.toLowerCase(); }).value();

                    var newSelectedFunctions = [];
                    for (var i = 0; i < vm.departmentsFunctionsLink.userChosenFunctions.length; i++) {
                        var find = vm.departmentsFunctionsLink.userChosenFunctions[i];
                        if (_.findWhere(vm.functions, { roleId: find.roleId })) newSelectedFunctions.push(find);
                    }
                    vm.departmentsFunctionsLink.userChosenFunctions = newSelectedFunctions;
                    return;
                });
            }
            else {
                vm.functions = departmentsAndFunctions.functions;
                deferred.resolve();
            }

            return deferred.promise;
        }

        function _updateSelection() {
            var selection = [];
            var departments = vm.departmentsFunctionsLink.addAllDepartments ? departmentsAndFunctions.departments : vm.departmentsFunctionsLink.userChosenDepartments;

            if (vm.onlyAssignToExistingCombinations) {
                $q.all(departments.map(dep => {
                    if (departmentFunctions[dep.id] != null) return;
                    return portalGroupService.getFunctions(dep.id).then(functions => {
                        departmentFunctions[dep.id] = functions;
                        return;
                    });
                })).then(() => {
                    for (var i = 0; i < departments.length; i++) {
                        var dep = departments[i];
                        var functions = departmentFunctions[dep.id];
                        var selectedFunctions = vm.departmentsFunctionsLink.addAllFunctions ? departmentsAndFunctions.functions : vm.departmentsFunctionsLink.userChosenFunctions;
                        
                        for (var j = 0; j < functions.length; j++) {
                            var func = functions[j];
                            if (_.findWhere(selectedFunctions, { roleId: func.roleId })) selection.push({ department: dep, function: func });
                        }
                    }
                    vm.selection = selection;
                });
            } else {
                var functions = vm.departmentsFunctionsLink.addAllFunctions ? departmentsAndFunctions.functions : vm.departmentsFunctionsLink.userChosenFunctions;

                for (var i = 0; i < departments.length; i++) {
                    var dep = departments[i];
                    for (var j = 0; j < functions.length; j++) {
                        var func = functions[j];
                        selection.push({ department: dep, function: func });
                    }
                }

                vm.selection = selection;
            }
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function ok() {
            $uibModalInstance.close(vm.selection);
        }

        function toggleOnlyAssignToExistingCombinations() {
            _updateAvailableFunctions().then(() => { _updateSelection(); });
        }
    }
})();